import type { NextPage } from 'next';
import { useEffect } from 'react';

import { getBaseUrlByEnv } from '@/constants/baseUrls';

const ShopRedirect: NextPage = () => {
  useEffect(() => {
    window.location.replace(`${getBaseUrlByEnv()}/shop/solar-quote/`);
  });

  return null;
};

export default ShopRedirect;
